export default __webpack_public_path__ + "static/media/Account_profile_edit_avatar.65139054.svg";